<template>
  <div class="page-container">
    <div class="d-flex align-items-center">
      <h5 class="mb-0 mr-auto">Услуги исполнителя</h5>
      <b-button class="custom-btn-primary" :disabled="disabled" @click.stop="onAdd()">
        <font-awesome-icon icon="plus" class="mr-1"/>
        Добавить
      </b-button>
    </div>
    <div class="page-body">
      <template v-if="items && items.length > 0">
      <div class="page-table-container">
        <b-table
          id="tw-services"
          ref="tw_services"
          class="custom-table text-small mb-0"
          selectable
          select-mode="single"
          responsive
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="sortCompare"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <tables-skeleton :fields="fields" :rows="3"/>
          </template>

          <template #cell(location_work_service_id)="row">
            <b-form-select
              id="tw_service_id"
              size="sm"
              :disabled="disabled"
              :value="row.item.location_work_service_id"
              :options="twsOptions"
              @change="onServiceSelected(row, $event)"
            />
          </template>

          <template #cell(quantity)="row">
            <b-form-input
              id="tw_quantity"
              size="sm"
              autocomplete="off"
              type="number"
              :min="0"
              :disabled="disabled"
              :value="row.item.quantity"
              @input="onQuantityInput(row.item, $event)"
              @blur="normalizeQuantity(row.item)"
              @keydown="preventMinus"
            />
          </template>

          <template #cell(price)="row">
            <b-form-input
              id="tw_price"
              size="sm"
              autocomplete="off"
              :disabled=true
              :value="row.item.price"
            />
          </template>

          <template #cell(unit)="row">
            <unit-select
              id="tw_unit"
              ref="unit_select"
              :initial-unit="row.item.unit_code"
              is-short
              @selectUnit="updateUnit($event, row)"
              :key="row.item.unit_code + '-' + row.index"
              :is-disabled=true
            />
          </template>

          <template #cell(total_price)="row">
            {{priceFormat(row.item.total_price)}}
          </template>

          <template #cell(action)="row">
            <b-button class="custom-btn-danger" :disabled="disabled" @click="onRemove(row)">
              <v-icon name="buttons/trash" :size="14"/>
            </b-button>
          </template>
        </b-table>
      </div>

      <div class="page-pagination">
        <pagination-footer
          :total-rows="items.length"
          :per-page="perPage"
          :current-page.sync="currentPage"
          @per-page-change="onPerPageChange"
        >
          <template #footer-update>
            <span :id="'total-sum-' + tw.id" :class="{'text-danger font-weight-bold': isMismatch}">
              Общая сумма: <b>{{ priceFormat(totalSum) }}</b>
            </span>
            <span class="text-small vertical-divider"/>
            <b-tooltip v-if="isMismatch" :target="'total-sum-' + tw.id" variant="danger">
              Сумма услуг исполнителя не совпадает с итого ({{ priceFormat(tw.total_price) }}).
            </b-tooltip>
          </template>
        </pagination-footer>
      </div>
      </template>

      <div v-else class="empty-state-container">
        <v-icon name="navbar/empty_table" :size="90"/>
        <h5>Нет добавленных услуг.</h5>
        <p>Добавьте услуги исполнителя прямо сейчас</p>
        <b-btn class="custom-btn-primary mt-1" :disabled="disabled" @click.stop="onAdd()">
          <v-icon name="buttons/plus" :size="12" class="mr-1"/>
          Новая услуга исполнителей
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import unitStore from "../../utilites/unitStore";
import helpers from "../../utilites/helpers";
  import UnitSelect from "../Catalogs/UnitSelect";
import TablesSkeleton from "../../utilites/commonUi/TablesSkeleton.vue";
import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";

export default {
  name: "TaskWorkerServices",
  components: { PaginationFooter, TablesSkeleton, UnitSelect },
  mixins: [ unitStore, helpers ],
  props: {
    tws: { type: Array, default: () => [] },
    tw: { type: Object, default: () => ({}) },
    twsOptions: { type: Array, required: false, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      fields: [
        {
          key: 'location_work_service_id',
          label: 'Вид услуг',
          class: '',
          sortable: false,
        },
        {
          key: 'quantity',
          label: 'Количество',
          class: '',
          sortable: false,
        },
        {
          key: 'price',
          label: 'Цена',
          class: '',
          sortable: false,
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          class: '',
          sortable: false,
        },
        {
          key: 'total_price',
          label: 'Итого',
          sortable: false,
          class: 'align-middle total_price',
        },
        {
          key: 'action',
          label: "Действия",
          class: 'text-center align-middle',
          tdClass: 'align-bottom',
          sortable: false,
        },
      ],
      perPage: 10,
      currentPage: 1,
      deleteRow: {
        id: null,
        location_work_service_name: ''
      },
      sortBy: 'id',
      sortDesc: true,
    }
  },
  computed: {
    items() {
      return this.tws || [];
    },
    totalSum() {
      return this.items.reduce((acc, item) => acc + (Number(item.total_price) || 0), 0);
    },
    isMismatch() {
      if (this.items.length === 0) {
        return false;
      }

      return Math.abs(this.totalSum - this.tw.total_price) > 0.01;
    }
  },
  methods: {
    updateItem(item, changes) {
      const items = this.items.map(currentItem =>
        currentItem === item ? { ...currentItem, ...changes } : currentItem
      );
      this.$emit('change', items);
    },
    updateUnit(unit, row) {
      this.updateItem(row.item, { unit_code: unit.code });
    },
    onAdd() {
      const data = {
        id: 0,
        location_id: this.locationId,
        location_work_id: null,
        location_work_service_id: null,
        location_work_service_name: '',
        quantity: 0,
        price: 0,
        total_price: 0,
        unit_code: '539',
      }
      this.$emit('change', [data, ...this.items]);
      this.currentPage = 1;
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление работы";
      const message = `Вы уверены, что хотите удалить ${this.deleteRow.location_work_service_name.toLowerCase()}?`;
      this.showModalDelete(title, message, function () {
        const index = this.items.findIndex(item => item === row.item);
        if (index < 0) return;

        const items = this.items.slice();
        items.splice(index, 1);
        this.$emit('change', items);
      }.bind(this));
    },
    onServiceSelected(row, serviceId) {
      const selectedOption = this.twsOptions.find(opt => opt.value === serviceId);

      if (selectedOption) {
        const details = selectedOption.details;
        const price = Number(details.price) || 0;
        const quantity = Number(row.item.quantity) || 0;

        this.updateItem(row.item, {
          location_id: details.location_id,
          location_work_service_id: details.id,
          location_work_service_name: details.work_service_name,
          price: price,
          unit_code: details.unit_code,
          total_price: price * quantity,
        });
        return;
      }

      this.updateItem(row.item, {
        location_work_service_id: null,
        location_work_service_name: '',
        price: 0,
        total_price: 0,
      });
    },
    onQuantityInput(item, value) {
      const quantity = value === '' ? '' : Number(value);
      this.updateItem(item, {
        quantity: quantity,
        total_price: (Number(item.price) || 0) * (Number(quantity) || 0),
      });
    },
    normalizeQuantity(item) {
      if (item.quantity !== '' && Number.isFinite(Number(item.quantity))) return;

      this.updateItem(item, { quantity: 0, total_price: 0 });
    },
    onPerPageChange(newPerPage) {
      this.perPage = Number(newPerPage);
      this.currentPage = 1;
    },
  },
}
</script>

<style>
#tw-services-pagination {
  margin-bottom: 0 !important;
}

.total_price {
  font-size: small !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Tasks/TaskWorkerServices.vue